import { type User, type UserSetting } from '@webapp/models'
import { type SimpleAPCreditCard } from '@webapp/models/APCreditCard'
import { ApiClient } from '../services/api'

export const ENDPOINT = '/api/v3/users/'

export const USERS_URL = ENDPOINT
export const USER_V2_URL = '/api/v2/user'

export interface UserInviteSchema
  extends Pick<User, 'is_sso_enabled' | 'firstName' | 'lastName' | 'email'> {
  location: number
  department: User['department']['id']
}

export interface FunctionalUserInviteSchema {
  email: User['email']
  first_name?: string
  last_name?: string
  role_id?: number
  send_invitation_email: boolean
  all_locations: boolean
  locations?: {
    id: number
    all_departments: boolean
  }[]
}

export const UserAPI = {
  getList: (params) => {
    return ApiClient.get<User[]>(USERS_URL, {
      params,
    })
  },
  getBasicList: (params) => {
    return ApiClient.get<User[]>(`${USERS_URL}basic/`, {
      params,
    })
  },
  getUserById: (id: User['id']) => {
    return ApiClient.get<User>(`${USERS_URL}${id}`)
  },
  getBasicUserById: (id: User['id']) => {
    return ApiClient.get<User>(`${USERS_URL}${id}/basic/`)
  },
  inviteUser: (data: UserInviteSchema) => {
    return ApiClient.post<UserInviteSchema, User>(USERS_URL, data)
  },
  functionalUserInvite: (data: FunctionalUserInviteSchema[]) =>
    ApiClient.post<FunctionalUserInviteSchema[]>(USERS_URL, data),
  getDelegatableApprovers: (params) =>
    ApiClient.get<User[]>(`${USERS_URL}delegatable-approvers/`, {
      params,
    }),
  getUserSettings: () => {
    return ApiClient.get<UserSetting>(`${USER_V2_URL}/me/setting/`)
  },
  getUserCreditCards: (userId: User['id'], params?) => {
    return ApiClient.get<SimpleAPCreditCard[]>(
      `${USERS_URL}${userId}/creditcards/`,
      {
        params,
      }
    )
  },
}
